<template>
  <div class="hello">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">项目名称</div>
            <!-- <el-input size="small" v-model="infoQuery.objname" @blur="getCustomerList()" @keyup.enter.native="$event.target.blur"></el-input> -->
            <el-input size="small" v-model="custname" @keyup.enter.native="getHisList()"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dropDownScreen" style="margin-right:24px">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="inputs">
          <div class="timeip formScreenInput">
            <div>操作时间</div>
            <el-date-picker
            style="width:300px!important;"
              v-model="impdate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
          <button class="search" @click="getHisList">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>

      
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/customerList' }">花名册</el-breadcrumb-item>
          <el-breadcrumb-item>历史花名册</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="p_roster_table">
        <!-- 招聘角色不能看雇员花名册 -->
        <el-tab-pane label="项目列表" name="项目列表" v-if="isCanProList"></el-tab-pane>
        <el-tab-pane label="在职" name="在职"></el-tab-pane>
        <el-tab-pane label="离职" name="离职"></el-tab-pane>
        <el-tab-pane label="离职转正" name="离职转正"></el-tab-pane>
        <el-tab-pane label="自离" name="自离"></el-tab-pane>
        <el-tab-pane label="黑名单雇员" name="黑名单雇员" v-if="roleType != 'recdirec' && roleType != 'recruit'"></el-tab-pane>
        <el-tab-pane label="历史花名册" name="历史花名册" v-if="roleType != 'recdirec' && roleType != 'recruit'"></el-tab-pane>
        <el-tab-pane label="导入导出记录" name="导入导出记录" v-if="roleType != 'recdirec' && roleType != 'recruit'"></el-tab-pane>
      </el-tabs>
      <div class="operationRecordTable">
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100">
            <template slot-scope="scope">
                <span>{{(currpage - 1) * pagecount + scope.$index + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrServCentName" min-width="15%"></el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrCustName" min-width="15%"></el-table-column>
          <el-table-column align="center" label="业务立项部门" prop="StrObjInstName" min-width="16%"></el-table-column>
          <el-table-column align="center" label="操作人" prop="StrServUsrName" min-width="15%"></el-table-column>
          <el-table-column align="center" label="负责客服" prop="StrUserName" min-width="15%"></el-table-column>
          <el-table-column align="center" label="备份时间" prop="DtBakDate" min-width="16%"></el-table-column>
          <el-table-column align="center" label="备份类型" prop="StrType" min-width="16%">
            <template slot-scope="{row}">
              <div v-if="row.StrType==1">手动</div>
              <div v-else>自动</div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="备份类型" prop="backupsType" min-width="16%"></el-table-column> -->
          <el-table-column align="center" label="备份数据" fixed="right" min-width="16%">
            <template slot-scope="{row}">
              <button class="changeServe" @click="goto(row)">查看详情</button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" min-width="16%" v-if="isCanHandle">
            <template slot-scope="{row}">
              <span v-if="isNull(row.BakExcelPath)">
                <i class="el-icon-loading"></i>
                 <span>下载文件正在生成中</span>
              </span>
              <button class="changeServe" @click="downloadHandle(row)" v-else>下载</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="Number(totalcount)>0">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import xz from "../../common";
export default {
  name: "HelloWorld",
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      activeName:'历史花名册',
      //角色类型
      roleType: '',
      tableHeight:0,
      pageSize:10,
      pagecount:10,
      listLoading:false,
      totalcount:0,
      custname:"",
       //下拉筛选
      showDropScreen:-1,
       impdate:[],
       datestart:'',
       dateend:'',
      //开始时间
      startDate:'',
      //结束时间
      endDate:'',
      currentPage3: 1,
      currentPage1: 1,
      tableData: [],
      currpage:1,
      // 按钮权限参数
      butQuery:{
        roletype:'',
        page:'customerList'
      },
      // 是否能看项目列表
      isCanProList:false,
      // 是否有权限操作按钮
      isCanHandle:false
    };
  },
  mounted(){
    this.roleType = localStorage.loginRoletype
    this.butQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()
    if(localStorage.loginRoletype.indexOf('admin')>-1||(localStorage.loginRoletype == 'customer')||(localStorage.loginRoletype == 'manager')){
      this.isCanProList = true
    }else{
      let tab = JSON.parse(localStorage.tableids);
      let isVisible = tab.some(function(item) {
        if (item.Strroletable == "jbuserbase") {// 是否有项目列表权限
          return true;
        }else{
          return false;
        }
      });
      if (isVisible) {
        this.isCanProList = true
      }else{
        this.isCanProList = false
      }
    }
    this.calHeight()
    this.getHisList()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
      console.log('height',this.tableHeight)
    },
    //切换tab
    async handleClick(tab, event) {
      // console.log('tab',tab, event);
      let pathList;
      if(this.roleType.indexOf('rec')==-1){// 不是招聘
        if(this.roleType.indexOf('admin')>-1){//管理员
          pathList = ['/customerList?currname=项目列表','/customerList?currname=在职','/customerList?currname=离职','/customerList?currname=离职转正','/customerList?currname=自离','/blacklist','/operationRecord']
        }else if((this.roleType == 'customer')||(this.roleType == 'manager')){//客服
          pathList = ['/customerList?currname=项目列表','/customerList?currname=在职','/customerList?currname=离职','/customerList?currname=离职转正','/customerList?currname=自离','/blacklist','/operationRecord']
        }else{
          if(this.isCanProList){
            pathList = ['/customerList?currname=项目列表','/customerList?currname=在职','/customerList?currname=离职','/customerList?currname=离职转正','/customerList?currname=自离','/blacklist','/operationRecord']
          }else{
            pathList = ['/customerList?currname=在职','/customerList?currname=离职','/customerList?currname=离职转正','/customerList?currname=自离','/blacklist','/operationRecord']
          }
        }
      }else{// 是招聘
        pathList = ['/customerList?currname=在职','/customerList?currname=离职','/customerList?currname=离职转正','/customerList?currname=自离']
      }
      this.$router.push({
        path: pathList[tab.index]
      })
    },
    // 获取按钮权限
    getButtonPower(){
      xz.getJbUserRolepageDetail(this.butQuery.roletype, this.butQuery.page).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let powerVal;
          if(!this.isNull(res.msg)){
            powerVal = res.msg[0].Buttons
          }
          if(powerVal == 'search'){
            // 只能查看
            this.isCanHandle = false
          }else if(powerVal == 'update'){
            // 特殊处理 只能更改客服
            this.isCanHandle = false
          }else if(powerVal == 'operation'){
            // 可操作
            this.isCanHandle = true
          }
        }else{
          this.isCanHandle = false
        }
      })
    },
    //筛选下拉
    dropDownScreen(){
     if( this.showDropScreen == -1){
        this.showDropScreen = 1
     }else if( this.showDropScreen == 1){
        this.showDropScreen = -1
     }
    },
    handleCurrentChange(val) {
      this.currpage = `${val}`;
      this.getHisList();
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pagecount = `${val}`;
        this.pageSize = parseInt(val);
        this.getHisList();
    },
    goto(item) {
      this.$router.push({
        path: "/employee-historyDetail",
        query: {
          gdbakId:item.GdBakId,
          custname:item.StrCustName,
          strServCentName:item.StrServCentName
        }
      });
    },
    //判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    },
    //下载
    downloadHandle(item){
      console.log('下载',item)
      if(this.isNull(item.BakExcelPath)){
        this.$message({
          message: '下载失败',
          type: 'warning'
        });
        return false
      }else{
        let d = item.BakExcelPath
        d = d.replace("\"","").replace("\"","")
        let path = this.tablePath + d
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click()
      }
    },
    resetHandle(){
      this.datestart = '';
      this.dateend = '';
      this.impdate = [];
      this.custname = ''
    },
    //获取历史列表
    getHisList(){
      this.listLoading = true;
      if(this.impdate){
        this.datestart = this.impdate[0];
        this.dateend = this.impdate[1]
      }
      const data = {
        custname:this.custname,
        pagecount:this.pagecount,
        currpage:this.currpage,
        datestart:this.datestart,
        dateend :this.dateend             
      }
      xz.getBackList(data).then(res=>{
        // console.log('ll',res)
        if(res.data&&res.data.length>0){
          res.data.forEach(l => {
            l.DtBakDate = l.DtBakDate.substring(0,10);
          });
          this.tableData = res.data;
          this.totalcount = parseInt(res.totalcount);
        }else{
          this.tableData = []
          this.totalcount = 0
        }
        this.listLoading = false
        this.showDropScreen = -1;
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-right .el-button--text{
  padding: 7px 10px;
  border: solid 1px #19BD92;
  font-size: 12px;
  color: #19BD92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img{
  vertical-align: sub;
}
</style>


<style >
.operationRecordTable .el-table td {
  padding: 5px 0;
}
.operationRecordTable .el-table th {
  padding: 10px 0;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.dialog .el-dialog__header {
  padding: 0;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
</style>